<div class="row">
  @if (isShareable) {
    <div class="col-12 col-md-auto">
      <button
        ds-button
        [variant]="DsButtonVariants.microActionHorizontalLayout"
        [microActionIcon]="Icons.ShareNodes"
        (click)="onShareReportRequest()"
        data-test-id="share-report"
      >
        {{ 'share_report' | translate }}
      </button>
    </div>
  }
  @if (canDownloadReport) {
    <div class="col-12 col-md-auto mt-md-0">
      <ds-dropdown data-test-id="export-report-button-dropdown">
        <ds-dropdown-toggle
          [variant]="displaySecondaryToggle() ? DsButtonVariants.secondary : DsButtonVariants.microActionHorizontalLayout"
          [icon]="displaySecondaryToggle() ? null : dropdownButtonIcon"
          label="{{ dropdownButtonLabel | translate }}"
        >
        </ds-dropdown-toggle>
        <div ds-dropdown-menu>
          @for (fileExtension of fileExtensions; track fileExtension) {
            <ds-dropdown-item
              [icon]="FileTypeIcons[fileExtension]"
              [attr.data-test-id]="'file-extension-' + fileExtension"
              (selected)="onDownloadReportRequest(fileExtension)"
              [value]="fileExtension"
              label="{{ 'download_report_as' | translate: fileExtension }}"
            >
            </ds-dropdown-item>
          }
        </div>
      </ds-dropdown>
    </div>
  }
</div>
